
import { Decimal } from 'decimal.js';
import numeral from 'numeral';

// 默认货币单位
export const defaultCurrencyUnit = '₹';
const currencyPrecision = 2; // 默认货币转换精度
const showPrecision = 2; // 默认小数点显示位数


/**
 * 精度转换（乘）一般用于入参
 * @param {金额} price
 * @param {默认调用配置项，但是某些接口是3位精度，需要单独设置，位数} cPrecision
 */
export function doParamsPrecision(price, cPrecision = 0) {
  const precision = cPrecision > 0 ? 10 ** cPrecision : 10 ** currencyPrecision;
  return Decimal.mul(price, precision).toNumber();
}

/**
 * 精度转换（除）一般用于页面展示前转化
 * @param {金额} price
 * @param {默认调用配置项，但是某些接口是3位精度，需要单独设置，位数} cPrecision
 */
export function doCurrencyPrecision(price, cPrecision = 0) {
  const precision = cPrecision > 0 ? 10 ** cPrecision : 10 ** currencyPrecision;
  return Decimal.div(price, precision).toNumber();
}


/**
 * 补全0
 * @param {*} price
 * @param precision 页面展示的精度
 * @param formatThousand 是否转化为千分位展示
 */
export function fixZeroPrecision(price, precision = showPrecision, formatThousand) {
  if (formatThousand) {
    let format = '0,0';
    for (let i = 0; i < precision; i += 1) {
      format += i === 0 ? '.0' : '0';
    }
    return numeral(price).format(format);
  }
  let strPrice = String(price);
  const dotIdx = strPrice.indexOf('.');
  const strLen = strPrice.length;
  let zeroLen = 0;
  if (dotIdx < 0) {
    zeroLen = precision;
  } else {
    zeroLen = precision - (strLen - dotIdx - 1);
  }
  if (dotIdx < 0 && precision > 0) {
    strPrice += '.';
  }
  for (let i = 0; i < zeroLen; i += 1) {
    strPrice += '0';
  }
  return strPrice;
}
